import MultiEditCustomTable from './MultiEditCustomTable';

export default MultiEditCustomTable;
